import { connect } from 'react-redux'
import TrainingsEntry from './trainings-entry'
import { getTraining } from '../../../../../../stores/trainings/trainings.selectors'
import { format } from 'date-fns'

const mapStateToProps = (state, { id }) => {
  const training = getTraining(state, id)
  return {
    id: training.id,
    title: training.title,
    createdAt: format(training.created_at, 'DD.MM.YYYY'),
    link: `/assessment-files/${training.id}`,
    //conclusion: training.concluded,
    //student: training.student_type && training.student_type.account.full_name,
    thumb:
      training.works &&
      training.works[0] &&
      training.works[0].media &&
      training.works[0].media[0] &&
      training.works[0].media[0].thumb_url,
    author: training.teacher_type && training.teacher_type.full_name,
    ageGroupTitle:
      training.student_types &&
      training.student_types[0] &&
      training.student_types[0].year_group &&
      training.student_types[0].year_group.title,
    ageGroupOrder:
      training.student_types &&
      training.student_types[0] &&
      training.student_types[0].year_group &&
      training.student_types[0].year_group.order
  }
}

export default connect(
  mapStateToProps,
  null
)(TrainingsEntry)
